//import Libraries
import React, { Component } from 'react';

//import Components
// import Layout from '../../hoc/Layout/Layout';
import DepartmentModule from '../../components/DepartmentModule/DepartmentModule';
// import Language from '../../language/language.json';

//import Style classes
import './Engineering.css'

const engineering = (props)=>{
    return (
        <DepartmentModule 
            page={props.match.params.page}
            type="engineering"/>
    )
}

export default engineering;


// WEBPACK FOOTER //
// ./src/pages/Engineering/Engineering.js